const requests = {
    diagrams: `/v1/co/diagrams`,
    templates: `/v1/co/diagrams-templates`,

    feedback: 'v1/co/feedback',

    checkoutRequest: `/v1/co/checkout-request`,

    // Invitations
    // invitationVerify: `/v1/co/invitations/verify`,
    // invitationAccept: `/v1/co/invitations/accept`,
    invitationVerify: `/v1/co/workspaces/invites/verify`,
    invitationAccept: `/v1/co/workspaces/invites/accept`,

    // Workspaces & teams
    // GET   /v1/co/workspaces                          → list user's workspaces
    // PATCH /v1/co/workspaces/:id                      → update workspace fields
    // GET   /v1/co/workspaces/:id/teams                → teams in a workspace
    // GET   /v1/co/workspaces/:id/members              → members in a workspace
    workspaces: `/v1/co/workspaces`,

    // User-scoped (preferences + active workspace)
    // PUT   /v1/co/users/me/active-workspace                 → set active workspace
    // GET   /v1/co/workspaces/:id/users/me/preferences       → fetch fully-merged prefs (workspace-scoped)
    // PATCH /v1/co/workspaces/:id/users/me/preferences       → partial update prefs (workspace-scoped)
    userActiveWorkspace: `/v1/co/users/me/active-workspace`,
    userPreferences: (workspaceId) => `/v1/co/workspaces/${workspaceId}/users/me/preferences`,
};

export default requests;
